import { apiUrl, authApiUrl } from '@/config/env'
import { SENTRY_ENV } from '@/constants/commonConstants'

const currentOrigin = window.location.origin
export const isLocal = currentOrigin.includes('localhost') || currentOrigin.includes('127.0.0.1')
export const isPreprod = currentOrigin.includes('blinkit.dev')
export const isProd = !isLocal && !isPreprod

export const appConfig = {
  baseUrl: apiUrl,
  authApiBaseUrl: authApiUrl,
  authApiKey: 'c158b623-3e38-4236-ab8b-404f806d0491',
  authApiKeyProd: 'f71e315e-a7b8-4e87-b448-5c56ed860828',
  appClient: 'mediamax_web_dashboard',
}

const baseImageUrl = 'https://cdn.grofers.com/layout-engine/v2/blinkit-studio/'
export const socialAdsStudioAssetsBaseUrl = 'https://cdn.grofers.com/da/social-ads-studio-assets/'
const createServiceUrl = (url: string) => `${appConfig.baseUrl}${url}`
const createAuthServiceUrl = (url: string) => `${appConfig.authApiBaseUrl}${url}`

export const imageUrls = {
  collab: {
    metaLogo: `${socialAdsStudioAssetsBaseUrl}meta_logo2.png`,
    googleLogo: `${socialAdsStudioAssetsBaseUrl}google_logo.png`,
    metaLogoWithName: `${socialAdsStudioAssetsBaseUrl}meta_logo_with_name.png`,
  },
  header: {
    mediaMaxLogo: `${baseImageUrl}2026-02/media_max_logo.png`,
  },
  home: {
    banner: {
      ctaBackground: `${baseImageUrl}2026-02/BG_lines.png`,
      yCombinator: `${baseImageUrl}2026-02/y_combinator_logo.png`,
      azcompany: `${baseImageUrl}2026-02/azcompany_logo.png`,
      blockChange: `${baseImageUrl}2026-02/blockchange_logo.png`,
    },
    digitalCampaigns: {
      audience: `${baseImageUrl}2026-02/group_3_rounded.png`,
      realTime: `${baseImageUrl}2026-02/grid_off_rounded.png`,
      mobileIcon: `${baseImageUrl}2026-02/app_promo_rounded.png`,
    },
    partnerLogos: {
      azah: `${socialAdsStudioAssetsBaseUrl}Landing_Page/brand_logo/azah_logo.png`,
      fruBon: `${socialAdsStudioAssetsBaseUrl}Landing_Page/brand_logo/fru_bon_logo.png`,
      manyPokoPants: `${socialAdsStudioAssetsBaseUrl}Landing_Page/brand_logo/many_poko_pants_circular2.png`,
      theFaceShop: `${socialAdsStudioAssetsBaseUrl}Landing_Page/brand_logo/the_face_shop_logo.png`,
      paradyes: `${socialAdsStudioAssetsBaseUrl}Landing_Page/brand_logo/paradyes_logo3.png`,
      plum: `${socialAdsStudioAssetsBaseUrl}Landing_Page/brand_logo/plum_logo2.png`,
      dotAndKey: `${socialAdsStudioAssetsBaseUrl}Landing_Page/brand_logo/dot_key_logo2.png`,
      wishCare: `${socialAdsStudioAssetsBaseUrl}Landing_Page/brand_logo/wish_care_logo.png`,
    },
    partnerLogosCircular: {
      paradyes: `${socialAdsStudioAssetsBaseUrl}Landing_Page/brand_logo/paradyes_circular_logo3.png`,
      manyPokoPants: `${socialAdsStudioAssetsBaseUrl}Landing_Page/brand_logo/many_poko_pants_circular2.png`,
      theFaceShop: `${socialAdsStudioAssetsBaseUrl}Landing_Page/brand_logo/face_shop_circular_logo2.png`,
    },
    heroGradient: `${baseImageUrl}2026-02/back_ground_gradient.png`,
    platformFeatures: `${socialAdsStudioAssetsBaseUrl}Landing_Page/home_platform_features_v2.webp`,
  },
  homeLottie: {
    landingPagePlatforms: `${socialAdsStudioAssetsBaseUrl}Landing_Page/landing_page_platforms5.json`,
    landingPagePlatformsPhone: `${socialAdsStudioAssetsBaseUrl}Landing_Page/landing_page_platforms_for_phone2.json`,
    metaPhone: `${socialAdsStudioAssetsBaseUrl}Landing_Page/meta_phone_lottie3.json`,
    googlePhone: `${socialAdsStudioAssetsBaseUrl}Landing_Page/google_phone_lottie3.json`,
    shoppableLinksPhone: `${socialAdsStudioAssetsBaseUrl}Landing_Page/shoppable_links_phone_lottie4.json`,
  },
  common: {
    blinkitRoundLogo: `${baseImageUrl}2026-02/blinkit_rounded_logo.png`,
    blinkitSquareLogo: `${socialAdsStudioAssetsBaseUrl}common/blinkit_square.webp`,
    googleLogoSingle: `${socialAdsStudioAssetsBaseUrl}common/google_logo_single.webp`,
  },
  appHome: {
    metaBanner: `${socialAdsStudioAssetsBaseUrl}home_page/home_meta_banner_v2.webp`,
    googleBanner: `${socialAdsStudioAssetsBaseUrl}home_page/home_google_banner_v2.webp`,
    shoppableLinksBanner: `${socialAdsStudioAssetsBaseUrl}home_page/home_shoppable_links_banner_v2.webp`,
  },
  audienceUpload: {
    manWithDog: `${baseImageUrl}2026-02/man_with_dog.avif`,
  },
  brandPage: {
    noDataToShow: `${socialAdsStudioAssetsBaseUrl}no_data.png`,
  },
}

const baseCdnUrl = 'https://cdn.grofers.com/da/consumer-android-assets/'

export const cdnAssets = {
  setupGuidePdf: `${baseCdnUrl}meta_ads_with_blinkit_setup_guide.pdf`,
}

export const socialAdsStudioVideoGuides = {
  bmCheckStatus: `${socialAdsStudioAssetsBaseUrl}bm_check_status_guide.mp4`,
  adAccount: `${socialAdsStudioAssetsBaseUrl}ad_account_guide.mp4`,
}

export const socialAdsStudioVideoThumbnails = {
  metaLinkGuideThumbnail: `${socialAdsStudioAssetsBaseUrl}meta_link_guide_thumb_v2.png`,
}

export const __mediamax_api_url_config__ = {
  sendOtp: createAuthServiceUrl('/auth/api/v1/email/send_otp'),
  verifyOtp: createAuthServiceUrl('/auth/api/v1/email/verify_otp'),
  getBrandAccessStatus: createServiceUrl('/api/v1/user/brand-access/status'),
  getBrandAccessOnboardingStatus: createServiceUrl('/api/v1/user/brand-access/onboarding-status'),
  requestBrandAccess: createServiceUrl('/api/v1/user/brand-access/request'),
  getAvailableBrands: createServiceUrl('/api/v1/user/brand-access/available'),
  getUserBrands: createServiceUrl('/api/v1/meta/user/brands'),
  getAudienceConfigurations: createServiceUrl('/api/v1/meta/audience/config'),
  getBrandDetails: createServiceUrl('/api/v1/meta/brand/details'),
  linkBrand: createServiceUrl('/api/v1/meta/brand/link'),
  checkLinkStatus: createServiceUrl('/api/v1/meta/brand/link/status'),
  verifyViewAccess: createServiceUrl('/api/v1/meta/brand/view-access/verify'),
  getLandingPage: createServiceUrl('/api/v1/meta/landing-page/config'),
  getLandingPageDetails: createServiceUrl('/api/v1/meta/landing-page/details'),
  createLandingPage: createServiceUrl('/api/v1/meta/landing-page/create'),
  createAudience: createServiceUrl('/api/v1/meta/audience/create'),
  listAudiences: createServiceUrl('/api/v1/meta/audiences'),
  listLandingPages: createServiceUrl('/api/v1/meta/landing-pages'),
  cloneAudienceConfig: createServiceUrl('/api/v1/meta/audience/clone'),
  retryAudience: createServiceUrl('/api/v1/meta/audience/retry'),
  getAudienceDetails: createServiceUrl('/api/v1/meta/audience/details'),
  getAppConfig: createServiceUrl('/api/v1/config'),
  listUserRequests: createServiceUrl('/api/v1/internal/brand-access/requests'),
  processBrandAccess: createServiceUrl('/api/v1/internal/brand-access/requests/process'),
  updateBrandAccessStatus: createServiceUrl('/api/v1/internal/brand-access/mappings/status'),
  listUserBrandMappings: createServiceUrl('/api/v1/internal/brand-access/mappings'),
  listMetaBrands: createServiceUrl('/api/v1/internal/meta/brands'),
  delinkMetaBrand: createServiceUrl('/api/v1/internal/meta/brand/delink'),
  listShoppableBrands: createServiceUrl('/api/v1/shoppable/brands'),
  getCampaignConfig: createServiceUrl('/api/v1/shoppable/campaign/config'),
  listShoppableCategories: createServiceUrl('/api/v1/shoppable/categories'),
  listShoppableCollections: createServiceUrl('/api/v1/shoppable/collections'),
  listShoppableProducts: createServiceUrl('/api/v1/shoppable/products'),
  validateCampaign: createServiceUrl('/api/v1/shoppable/campaign/validate'),
  createCampaign: createServiceUrl('/api/v1/shoppable/campaign/create'),
  validateLinks: createServiceUrl('/api/v1/shoppable/links/validate'),
  getLinksTemplate: createServiceUrl('/api/v1/shoppable/links/template'),
  getShoppableDashboardConfig: createServiceUrl('/api/v1/shoppable/dashboard/config'),
  getShoppableDashboardKpis: createServiceUrl('/api/v1/shoppable/dashboard/kpis'),
  getShoppableDashboardTrend: createServiceUrl('/api/v1/shoppable/dashboard/trend'),
  getShoppableDashboardBreakdowns: createServiceUrl('/api/v1/shoppable/dashboard/breakdowns'),
  listShoppableCampaigns: createServiceUrl('/api/v1/shoppable/campaigns'),
  getShoppableCampaignReport: createServiceUrl('/api/v1/shoppable/campaign/report'),
  downloadShoppableCampaignLinks: createServiceUrl('/api/v1/shoppable/campaign/links/download'),
  listInternalShoppableCampaigns: createServiceUrl('/api/v1/internal/shoppable/campaigns'),
  updateShoppableCampaignStatus: createServiceUrl('/api/v1/internal/shoppable/campaign/status'),
  updateShoppableLinksStatus: createServiceUrl('/api/v1/internal/shoppable/links/status'),
}

type RuntimeProcessEnv = {
  process?: {
    env?: Record<string, string | undefined>
  }
}

const getRuntimeSentryDsn = (): string | undefined => {
  if (isLocal) {
    return import.meta.env.VITE_SENTRY_DSN
  }
  const runtimeProcessEnv = globalThis as unknown as RuntimeProcessEnv
  return runtimeProcessEnv.process?.env?.SENTRY_DSN ?? import.meta.env.VITE_SENTRY_DSN
}

export const SentryDSN = getRuntimeSentryDsn()

const getSentryEnvironment = (): string => {
  if (isProd) return SENTRY_ENV.production
  if (isPreprod) return SENTRY_ENV.preProd
  return SENTRY_ENV.development
}

export const SentryENV = getSentryEnvironment()

export const SENTRY_RELEASE_VERSION = '0.0.1'

export const OTP_LENGTH = 6
export const RESEND_TIMER_SECONDS = 30
export const MAX_VISIBLE_BRANDS_IN_MODAL = 4
